<template>
  <div class="mongo-instanceLog-page">
    <Card>
      <Row>
        <i-col span="21">
          <h1>{{this.$route.query.name}}</h1>
        </i-col>
        <i-col span="3">
          <Button style="float: right;" @click="refresh()" type="primary" :style="{marginBottom: '10px'}" icon="md-refresh">刷新</Button>
        </i-col>
      </Row>
      <Divider />
      <Row>
        <i-col span="24">
          <Form ref="searchForm" inline :model="searchForm" onsubmit="return false;">
            <FormItem prop="name">
              <i-input clearable placeholder="Content 内容" v-model="searchForm.name" style="min-width: 200px;" search
                        @on-enter="getInstanceLog()"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getInstanceLog()">搜索</Button>
              <Button @click="searchReset()" style="margin-left: 10px;">重置</Button>
            </FormItem>
            <FormItem prop="date" style="float: right;text-align:right;margin-right:0;">
              <DatePicker type="daterange" :value="dateValue" :options="dateOption" placement="bottom-end"
                          placeholder="Select date" @on-change="getInstanceLog"></DatePicker>
            </FormItem>
          </Form>
        </i-col>
      </Row>
      <tables ref="instanceLogTable" height="600" search-place="top" v-model="instanceLogData"
              :columns="instanceLogColumns" class="mob-remove-table-fixed"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getInstanceLog"></page>
        </div>
      </Row>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import {getInstanceLogList} from '@/api/mongodb'

export default {
  name: 'MongoDBInstanceLog',
  components: {
    Tables
  },
  data: function () {
    return {
      searchForm: {
        name: ''
      },
      count: 1,
      size: 15,
      page: 1,
      dateValue: [new Date().toISOString().slice(0, 10), new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().slice(0, 10)],
      dateOption: {
        shortcuts: [
          {
            text: '今天',
            value () {
              const start = new Date()
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              return [start, end]
            }
          },
          {
            text: '三天',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
              return [start, end]
            }
          },
          {
            text: '一周',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
              return [start, end]
            }
          },
          {
            text: '一个月',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
              return [start, end]
            }
          },
          {
            text: '三个月',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
              return [start, end]
            }
          }
        ]
      },
      is_superuser: false,
      instanceLogColumns: [
        {title: '日志内容', key: 'log'}
      ],
      instanceLogData: []
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      if (this.$route.query.id) {
        this.refresh()
      }
    }
  },

  methods: {
    searchReset () {
      this.searchForm.name = ''
      this.searchForm.date = [new Date().toISOString().slice(0, 10), new Date().toISOString().slice(0, 10)]
      this.getInstanceLog()
    },
    refresh () {
      this.getInstanceLog()
    },
    getInstanceLog (value = 1) {
      if (typeof value === 'number') {
        this.page = value
      } else {
        let end = new Date(value[1])
        end.setTime(end.getTime() + 3600 * 1000 * 24)
        this.dateValue[0] = value[0]
        this.dateValue[1] = end.toISOString().slice(0, 10)
      }
      let params = {
        id: this.$route.query.id,
        page: this.page,
        size: this.size,
        start_time: this.dateValue[0],
        end_time: this.dateValue[1],
        search: this.searchForm.name
      }
      getInstanceLogList(params).then(res => {
        this.instanceLogData = res.data.results
        this.count = res.data.count
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取进程列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取进程列表失败！服务器无响应'
          })
        }
      })
    }
  },

  mounted: function () {
    this.getInstanceLog()
  }
}
</script>
<style lang="less">
  @media screen and (max-width:640px) {
    .mongo-instanceLog-page {
      h1 {
        font-size: 1.5em;
      }
      .ivu-divider-horizontal{
        margin:0px 0 15px;
      }
    }
  }
</style>
